export enum LoanGridType {
    MasterNotes = 1,
    SubNotes = 2,
    Construction = 3,
    Rental = 4,
    BuildRent = 5,
    FixFlip = 6,
    Land = 7,
    Model = 8,
    Bridge = 9,
}
